@if (showLoader()) {
  <app-loader-global />
} 
<router-outlet />
